// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + chunkId + "." + {"238": "530a72c0","284": "c6cf9ad3",}[chunkId] + ".chunk.js"
}